/**
 * Which routes are BROWSER SOURCES rather than Console pages.
 *
 * ==================== WHY THIS IS ONE FUNCTION ====================
 * `main.tsx` wraps every route in SessionProvider, PreferencesProvider and
 * PaintsProvider, so each of them boots on the alert overlay and the widget
 * runtime too. Both pages then took 401s for `/auth/me` and `/preferences` on
 * load — observed in a real browser against dev on 2026-09-11, and invisible
 * to the test suite because a 401 is exactly what those providers expect from
 * an anonymous visitor on /login.
 *
 * It is wrong for three reasons that matter: §103.6 says a browser source
 * carries its token and nothing else, §77 asks it to stay light for a page
 * that is open for hours, and an operator previewing a widget in their own
 * signed-in browser would send their session cookie to a page with no use for
 * it.
 *
 * One helper rather than the same two-line check copied into three providers —
 * the same reasoning that put the transparency rules in one stylesheet. A
 * fourth provider added later should call this, and a route added to this list
 * should fix all of them at once.
 * ==================================================================
 *
 * Matched on pathname because these providers sit ABOVE the router in
 * `main.tsx` and have no route context to consult.
 */
export function isBrowserSourceRoute(pathname: string = window.location.pathname): boolean {
  // Defensive against a test that stubs `location` without a pathname, which
  // is how this first reached production as a crash rather than a no-op.
  if (typeof pathname !== 'string') return false;

  return pathname === '/widget' || pathname.startsWith('/overlay/');
}
